export const resources = {
  "states": {
    "US-AL": {
      "documents": [{
        "link": "http:\/\/www.alasphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Alabama Asphalt Pavement Association ",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-AZ": {
      "documents": [{
        "link": "http:\/\/www.azagc.org\/",
        "icon": "icon-HTML.png",
        "title": "Arizona Chapter Associated General Contractors",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-AR": {
      "documents": [{
        "link": "http:\/\/www.arasphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Arkansas Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-CA": {
      "documents": [{
        "link": "http:\/\/www.calapa.net\/",
        "icon": "icon-HTML.png",
        "title": "California Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-CO": {
      "documents": [{
        "link": "http:\/\/www.co-asphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Colorado Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.co-asphalt.com\/documents\/asphaltlparkinglotdesignguide1.pdf",
        "icon": "icon-PDF.png",
        "title": "Colorado Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-FL": {
      "documents": [{
        "link": "http:\/\/www.FloridaRidesOnUs.org",
        "icon": "icon-HTML.png",
        "title": "Asphalt Contractors Association of Florida",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-GA": {
      "documents": [{
        "link": "http:\/\/www.gahotmix.com\/",
        "icon": "icon-HTML.png",
        "title": "Georgia Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-HI": {
      "documents": [{
        "link": "http:\/\/hawaiiasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Hawaii Asphalt Paving Industry",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-IL": {
      "documents": [{
        "link": "http:\/\/www.il-asphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Illinois Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-IN": {
      "documents": [{
        "link": "http:\/\/www.asphaltindiana.org\/",
        "icon": "icon-HTML.png",
        "title": "Asphalt Pavement Association of Indiana",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-IA": {
      "documents": [{
        "link": "http:\/\/www.apai.net\/",
        "icon": "icon-HTML.png",
        "title": "Asphalt Paving Association of Iowa",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.apai.net\/cmdocs\/apai\/designguide\/Chapter_5B.pdf",
        "icon": "icon-PDF.png",
        "title": "Iowa Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-KS": {
      "documents": [{
        "link": "http:\/\/www.ksasphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Kansas Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-KY": {
      "documents": [{
        "link": "http:\/\/www.paiky.org\/",
        "icon": "icon-HTML.png",
        "title": "The Plantmix Asphalt Industry of Kentucky",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/paiky.org\/wp-content\/uploads\/2012\/06\/Parking_Lot_Guide.pdf",
        "icon": "icon-PDF.png",
        "title": "Kentucky Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-LA": {
      "documents": [{
        "link": "http:\/\/www.lahotmix.org\/",
        "icon": "icon-HTML.png",
        "title": "Louisiana Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-ME": {
      "documents": [{
        "link": "http:\/\/maine-apa.org\/",
        "icon": "icon-HTML.png",
        "title": "Maine Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-MD": {
      "documents": [{
        "link": "http:\/\/mdasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "The Maryland Asphalt Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/mdasphalt.org\/wp-content\/uploads\/2010\/10\/2008MAADesignGuide.pdf",
        "icon": "icon-PDF.png",
        "title": "Maryland Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-MA": {
      "documents": [{
        "link": "http:\/\/www.massasphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Massachusetts Aggregate and Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-MI": {
      "documents": [{
        "link": "http:\/\/www.apa-mi.org\/",
        "icon": "icon-HTML.png",
        "title": "Asphalt Pavement Association of Michigan",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-MN": {
      "documents": [{
        "link": "http:\/\/www.asphaltisbest.com\/wp-content\/uploads\/2015\/01\/MAPA-Asphalt-Paving-Design-Guide_web.pdf",
        "icon": "icon-HTML.png",
        "title": "Minnesota Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.asphaltisbest.com\/wp-content\/uploads\/2015\/01\/MAPA-Asphalt-Paving-Design-Guide_Chapter4.pdf",
        "icon": "icon-PDF.png",
        "title": "Minnesota Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-MS": {
      "documents": [{
        "link": "http:\/\/www.msasphalt.com\/",
        "icon": "icon-HTML.png",
        "title": "Mississippi Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.msasphalt.com\/images\/user_files\/Parking%20Lots%20MS%202009.pdf",
        "icon": "icon-PDF.png",
        "title": "Mississippi Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-MO": {
      "documents": [{
        "link": "http:\/\/moasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Missouri Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-NJ": {
      "documents": [{
        "link": "http:\/\/www.njapa.com\/",
        "icon": "icon-HTML.png",
        "title": "New Jersey Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-NY": {
      "documents": [{
        "link": "http:\/\/www.nymaterials.com\/",
        "icon": "icon-HTML.png",
        "title": "New York Construction Materials Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-NC": {
      "documents": [{
        "link": "http:\/\/www.carolinaasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Carolina Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-ND": {
      "documents": [{
        "link": "http:\/\/www.dakota-asphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Dakota Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-OH": {
      "documents": [{
        "link": "http:\/\/www.dot.state.oh.us\/Divisions\/Engineering\/Pavement\/Pavement%20Design%20%20Rehabilitation%20Manual\/Forms\/AllItems.aspx",
        "icon": "icon-HTML.png",
        "title": "Ohio Department of Transportation Pavement Design Manual",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.flexiblepavements.org\/technical-resources\/design-guide\/design-guide",
        "icon": "icon-PDF.png",
        "title": "Ohio Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-OK": {
      "documents": [{
        "link": "http:\/\/www.okhotmix.com\/",
        "icon": "icon-HTML.png",
        "title": "Oklahoma Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.okhotmix.com\/Websites\/oapa\/Images\/Parking%20Lot%20Design%20Manual%20for%20Web.pdf",
        "icon": "icon-PDF.png",
        "title": "Oklahoma Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-OR": {
      "documents": [{
        "link": "http:\/\/www.apao.org\/",
        "icon": "icon-HTML.png",
        "title": "Asphalt Pavement Association of Oregon",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-PA": {
      "documents": [{
        "link": "http:\/\/www.pahotmix.org\/",
        "icon": "icon-HTML.png",
        "title": "Pennsylvania Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.pahotmix.org\/pdf\/Design_Guide.pdf",
        "icon": "icon-PDF.png",
        "title": "Pennsylvania Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-SC": {
      "documents": [{
        "link": "http:\/\/www.scasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "South Carolina Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-SD": {
      "documents": [{
        "link": "http:\/\/www.dakota-asphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Dakota Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-TN": {
      "documents": [{
        "link": "http:\/\/www.trba.org\/",
        "icon": "icon-HTML.png",
        "title": "Tennessee Road Builders Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-TX": {
      "documents": [{
        "link": "http:\/\/texasasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Texas Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-UT": {
      "documents": [{
        "link": "http:\/\/www.utahasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Utah Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }]
    },
    "US-VA": {
      "documents": [{
        "link": "http:\/\/www.vaasphalt.org\/",
        "icon": "icon-HTML.png",
        "title": "Virginia Asphalt Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.vaasphalt.org\/parking-lot-design\/",
        "icon": "icon-PDF.png",
        "title": "Virginia Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-WA": {
      "documents": [{
        "link": "http:\/\/www.asphaltwa.com\/",
        "icon": "icon-HTML.png",
        "title": "Washington Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.asphaltwa.com\/2010\/09\/17\/parking-lots-2\/",
        "icon": "icon-PDF.png",
        "title": "Washington Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-WV": {
      "documents": [{
        "link": "http:\/\/www.asphaltwv.com\/",
        "icon": "icon-HTML.png",
        "title": "Asphalt Pavement Association of West Virginia",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.transportation.wv.gov\/highways\/engineering\/DD\/2006%20DD%20Manual%20MASTER%2006112013.pdf",
        "icon": "icon-PDF.png",
        "title": "West Virginia Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    },
    "US-WI": {
      "documents": [{
        "link": "http:\/\/www.wispave.org\/",
        "icon": "icon-HTML.png",
        "title": "Wisconsin Asphalt Pavement Association",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}]
      }, {
        "link": "http:\/\/www.wispave.org\/downloads\/WAPA_2001_Design_Guide.pdf",
        "icon": "icon-PDF.png",
        "title": "Wisconsin Asphalt Parking Lot Design Guide",
        "text": "",
        "validation": [{"key": "pavement_type", "value": "flexible", "comparison": "EQ"}, {
          "key": "classification",
          "value": "parking lot",
          "comparison": "EQ"
        }]
      }]
    }
  }
}
